import { Pencil } from 'lucide-react';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';
import { usePermission } from '../../../../hooks/usePermission';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';
/* eslint-disable */

function PropertiesView({ data, onEdit }) {
  const { isEditable } = usePermission();
  const prepareData = () => {
    if (!data) return [];
    return [
      { name: 'Název', value: data.title },
      { name: 'Zkratka', value: data.shortcut },
      { name: 'Popis', value: data.description },
      { name: 'Jednotka', value: data.unit?.title },
    ];
  };

  return (
    <div>
      <Bar
        text="Detail"
        content={
          isEditable
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={onEdit}
                  data-testid="properties-view-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions
        objectType="propertydefinition"
        objectId={data?.id}
        status={data?.status}
      />
      <List data={prepareData()} />
      <div className="mb-px">
        <Bar text="Biblio" />
        <List
          data={(data?.biblios || []).map((biblio) => ({
            name: biblio.title,
          }))}
        />
      </div>
      <div className="mb-px">
        <Bar text="Nabývá hodnot" />
        <List
          data={(data.value_choices || []).map((choice) => ({
            name: choice.value,
            value: choice.description,
          }))}
        />
      </div>
    </div>
  );
}

export default PropertiesView;
